import React from "react";
import StaticPageHeader from "./StaticPageHeader";
import SplitText from "./Animations/SplitText";

const PageHeader = ({ title, animateTitle = true, ...props }) => (
	<StaticPageHeader
		{...props}
		title={title && animateTitle ? <SplitText>{title}</SplitText> : title}
	/>
);

export default PageHeader;
